import { AlertType } from "Components/Form/Alert";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export interface ErrorDisplayedState {
  errorType?: UserInputError | UserInputObstacle;
  errorText?: string;
  fieldInfo?: FieldInfo;
}

export const errorDisplayedStateToString = (
  error: ErrorDisplayedState,
): string =>
  `${error.errorType ? error.errorType + " " : ""}` +
  `${error.errorText ? error.errorText + " " : ""}` +
  `${error.fieldInfo?.alertType ? error.fieldInfo.alertType + " " : ""}` +
  `${error.fieldInfo?.fieldId ? error.fieldInfo.fieldId + " " : ""}`;

export interface FieldInfo {
  alertType: AlertType;
  fieldId?: string;
  productName?: INSURANCE_NAME_VALUE;
  stepId?: string;
  additionalInfo?: string | string[];
}

export enum UserInputError {
  FIELD_INPUT_ERROR = "FIELD_INPUT_ERROR",
}

export enum UserInputObstacle {
  ALERT_OBSTACLE = "ALERT_OBSTACLE",
}
